<template>
  <div class="modal fade" :id="idModalPrint" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" :class="{ 'modal-lg':isXl }">
            <div class="modal-content" >
                
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">{{ title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body">
                        <div v-html="contentPrint" id="sectionPrint"></div>
                </div>
                <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="printDoc"><font-awesome-icon icon="print" /></button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'modal-print',
    props:{
        title:String,
        idModalPrint:String,
        contentPrint:String,
        isXl:Boolean
    },
    data(){
        return{

        }
    },
    methods:{
        printDoc(){
            console.log('llamando a la impresion de esta parte');
            this.$htmlToPaper('sectionPrint');
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modal/modalPrint.vue